// extracted by mini-css-extract-plugin
export default {"container":"view-additional-info-part_container__FXwb4","adtitleContainer":"view-additional-info-part_adtitleContainer__b9UHa"};